import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.ABOUT_COMPANY}.${BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.SWOT}` as const;

export const ABOUT_COMPANY_SWOT_NAMES = {
  OPPORTUNITIES: 'opportunities',
  THREATS: 'threats',
} as const;

export const SWOT_ROW_NAMES = {
  TITLE: 'title',
} as const;

export interface ISwotAnalysisRowForm {
  [SWOT_ROW_NAMES.TITLE]: string;
}

export interface ISwotAboutCompanyForm {
  [ABOUT_COMPANY_SWOT_NAMES.OPPORTUNITIES]: ISwotAnalysisRowForm[];
  [ABOUT_COMPANY_SWOT_NAMES.THREATS]: ISwotAnalysisRowForm[];
}

export const analysisRowInitialValues: ISwotAnalysisRowForm = {
  [SWOT_ROW_NAMES.TITLE]: '',
};

export const swotAboutCompanyInitialValues: ISwotAboutCompanyForm = {
  [ABOUT_COMPANY_SWOT_NAMES.OPPORTUNITIES]: [analysisRowInitialValues],
  [ABOUT_COMPANY_SWOT_NAMES.THREATS]: [analysisRowInitialValues],
};

export const ABOUT_COMPANY_MAX_LENGTHS = {
  SWOT_ROW: 500,
};
